// extracted by mini-css-extract-plugin
export var active = "_f0-7";
export var container = "_f0-0";
export var evenWidth = "_f0-4";
export var large = "_f0-5";
export var outlet = "_f0-8";
export var slide = "_f0-2";
export var small = "_f0-6";
export var tab = "_f0-3";
export var tabs = "_f0-1";